import Vue from 'vue'
import Vuex from 'vuex'
import { stopNativeTracking } from '@/services/nativeTracking'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    android: false,
    theme: 1,
    empresas: [],
    pedidos: [],
    user: { nome_membro: '', token: null, id_setor: '', id_regional: '' },
    online: true,
    pwaPrompt: null,
    pwaInstalled: false,
    canPlay: false,
    soundMuted: !!localStorage.getItem('silenciar'),
    navegacao: 1,
    geoLocation: false,
    trackingServer: null,
    tracking: {
      mode: null,
      active: false,
      gpsStatus: null,
      serverStatus: null,
      lastCapturedPosition: null,
      lastCapturedAt: null,
      lastSentPosition: null,
      lastSentAt: null,
      pendingPosition: null,
      retryAt: null,
      lastError: null
    }
  },

  mutations: {
    setDadosApp: (state, data) => {
      state.dados = data;
    },

    setDataUser: (state, data) => {
      state.user = data.dados;
      //localStorage.setItem('appData', JSON.stringify(data));
    },

    setPrompt(state, data) {
      state.pwaPrompt = data;
    },

    setPwaInstalled(state, installed) {
      state.pwaInstalled = installed;
    },

    logout(state) {
      stopNativeTracking().catch(error => console.log('stopNativeTracking', error));
      const tema = localStorage.getItem('theme');
      localStorage.clear();
      state.user = {};
      state.pedidos = [];
      state.empresas = [];
      localStorage.setItem('theme', tema || 2);
      window.location.reload();
    }
  },

  actions: {
  },

  modules: {
  }
})
